<template>
	<div class="ms-talkmessage-edit-photoalbum">
		<Loading v-if="loading" opacity="0.5"/>
		<v-toolbar flat class="header" color="primary" height="60px" style="z-index: 103;">
			<template v-if="!is_selecting_images">
				<v-toolbar-items>
					<v-btn flat dark @click="onClickBack"><v-icon>chevron_left</v-icon></v-btn>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-layout style="align-items: center;">
						<v-flex>
							<h4 class="album-title">アルバム作成</h4>
						</v-flex>
					</v-layout>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-btn flat dark @click="onClickMenu"><v-icon>menu</v-icon></v-btn>
					<transition>
						<div class="menu">
							<div class="menu-list-group" v-if="is_menu_opened">
								<v-btn flat block large class="menu-list-item"
									:disabled="!(album && album.items.length > 0)"
									@click="onClickStartSelectingImages"
								>写真を選択</v-btn>
							</div>
						</div>
					</transition>
				</v-toolbar-items>
			</template>
			<template v-else>
				<v-toolbar-items>
					<v-btn flat dark color="white" @click="onClickCancelSelectingImages">キャンセル</v-btn>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-layout style="align-items: center;">
						<v-flex>
							<h4 class="album-title">{{ selected_images.length }}枚を選択中</h4>
						</v-flex>
					</v-layout>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-btn flat dark color="white" @click="onClickSelectAllImages">すべて選択</v-btn>
				</v-toolbar-items>
			</template>
		</v-toolbar>
		<div  style="padding-top: 60px; padding-bottom:56px;">
			<div class="pa-2" v-if="album">
				<v-layout>
					<v-spacer />
					<v-btn flat color="info"
						:disabled="is_selecting_images || !this.album || this.album.items.length == 0"
						@click="onClickCreateAlbum"
					>作成</v-btn>
				</v-layout>
				<v-form ref="form_title">
					<v-text-field
						ref="input_title"
						v-model="album.title"
						maxlength="50"
						:rules="[RULES.length_title]"
						:placeholder="placeholderTitle"
						single-line
					/>
				</v-form>
				<h2>写真</h2>
				<template v-if="album.items.length > 0">
					<v-layout wrap>
						<v-flex xs6 sm4 md3 lg2 xl1 v-for="item in album.items" :key="item.id" class="pa-1">
							<div style="position: relative">
								<div :style="styleImage" @click="onClickImage(item.id)" >
									<img :src="item.images.thumbnail.src" style="width:100%;" />
								</div>
								<v-btn v-if="is_selecting_images" fab
									color="white"
									:outline="!isSelectedImage(item.id)"
									class="btn-image-select"
									@click="onClickToggleSelectImage(item.id)"
								>
									<v-icon v-if="isSelectedImage(item.id)">done</v-icon>
								</v-btn>
							</div>
						</v-flex>
					</v-layout>
				</template>
				<template v-else>
					<p class="info--text text-xs-center pa-2">
						写真を選択してください。
					</p>
				</template>
			</div>
		</div>
		<MSToolbarCamera v-if="!is_selecting_images"
			:resolution="is_camera_resolution_original"
			@change-resolution="onChangeCameraResolution"
			@click-open-file="onClickOpenFile"
			@change-file="onChangeFile"
		/>
		<v-layout class="selecting-menu white" outline v-else>
			<v-flex xs12>
				<v-btn flat block dark color="#ff5252" @click="onClickDeleteSelectedImages">削除</v-btn>
			</v-flex>
		</v-layout>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickDialogAgree"
			@disagree="onClickDialogDisagree"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import APIClient from '../../classes/APIClient';
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import Loading from '../Loading';
import Util from '../../classes/Util';
import uuidv4 from 'uuid/v4';
import ConoHa from '../../classes/ConoHa';
import { IMAGE_MAX_SIZE, PHOTOALBUM_IMAGE_MAX_COUNT } from '../../data/Const';
import GBDialog from '../GBDialog';
import MSToolbarCamera from '../PhotoAlbum/MSToolbarCamera';

const strftime = require('strftime');

const validateLengthTitle = (value) => {
	if (value === undefined || value === null)
		return true;
	if (value.length <= 50)
		return true;

	return false;
};
export default {
	data() {
		const state_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				if(!obj.target.closest('.menu')){
					this.is_menu_opened = false;
				}
			},
		});
		return {
			msm: new MouseStateMachine(state_default),
			api: null,
			conoha: null,
			album: null,
			selected_images: [],
			loading: false,
			is_menu_opened: false,
			is_selecting_images: false,
			camera_menu_toggle: -1,
			is_camera_resolution_original: false,
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			RULES: {
				length_title: v => validateLengthTitle(v) || '50文字以内で入力してください',
			},
		};
	},
	components: {
		Loading,
		GBDialog,
		MSToolbarCamera,
	},
	methods: {
		initData: function() {
			this.album = {
				title: '',
				items: [],
			};
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onClickBack: function() {
			let uri = '/' + [
				this.$route.params.contractor_id, 'member', this.$route.params.id,
				'talkroom', this.$route.params.talkroom_id,
			].join('/');
			this.$router.push(uri);
		},
		onClickMenu: function() {
			this.is_menu_opened = !this.is_menu_opened;
		},
		onClickStartSelectingImages: function() {
			this.is_menu_opened = false;

			this.selected_images = [];
			this.is_selecting_images = true;
		},
		onClickCancelSelectingImages: function() {
			this.is_selecting_images = false;
			this.selected_images = [];
		},
		onClickSelectAllImages: function() {
			this.selected_images = this.album.items.map(item => item.id);
		},
		onClickImage: function(id) {
			if (this.is_selecting_images)
				this.onClickToggleSelectImage(id);
		},
		onClickToggleSelectImage: function(id) {
			let index = this.selected_images.indexOf(id);
			if (index >= 0)
				this.selected_images.splice(index, 1);
			else
				this.selected_images.push(id);
		},
		onClickDeleteSelectedImages: async function() {
			if (this.selected_images.length === 0) {
				this.errorDialog('画像を選択してください');
				return;
			}
			this.selected_images.forEach(id => {
				let index = this.album.items.findIndex(item => {
					return item.id === id;
				});
				if (index >= 0)
					this.album.items.splice(index, 1);
			});
			this.onClickCancelSelectingImages();
		},
		onClickOpenFile: function(done) {
			done();
		},
		onChangeCameraResolution: function(original) {
			this.is_camera_resolution_original = original;
		},
		onChangeFile: function(e) {
			let files = e.target.files || e.dataTransfer.files;
			if (files.length === 0)
				return;
			if (PHOTOALBUM_IMAGE_MAX_COUNT < this.album.items.length + files.length) {
				this.errorDialog("登録枚数の上限を超えています。\n[" + PHOTOALBUM_IMAGE_MAX_COUNT + '枚まで]');
				return;
			}

			let failure = [];
			let size_list = this.is_camera_resolution_original
				? [
					IMAGE_MAX_SIZE.ORIGINAL,
					IMAGE_MAX_SIZE.THUMBNAIL,
				] : [
					IMAGE_MAX_SIZE.SXGA,
					IMAGE_MAX_SIZE.THUMBNAIL,
				];

			this.loading = true;
			Util.chunkSplitPromiseAll(files, (file) => {
				let name = file.name;
				let type = file.type;
				let item = {
					id: uuidv4(),
					thumbnail_uri: null,
					photo_uri: null,
					images: {},
				};
				let file_id = item.id;
				return Promise.all(size_list.map(size => {
					return this.conoha.generateImage(file, size)
						.then((res) => {
							let key = size === IMAGE_MAX_SIZE.THUMBNAIL ? 'thumbnail' : 'photo';
							item.images[key] = {
								'file_id': file_id,
								'blob': res.blob,
								'src' : res.url,
								'name': size.PREFIX + name,
								'type': type,
								'size': size,
								'setURI': uploaded => {
									if (size === IMAGE_MAX_SIZE.THUMBNAIL)
										item.thumbnail_uri = uploaded.src;
									else
										item.photo_uri = uploaded.src;
								},
							};
						})
						.catch((e) => {
							failure.push(e);
						});
				}))
				.then(() => {
					this.album.items.push(item);
				});
			})
			.then(() => {
				if (failure.length > 0) {
					this.error("ファイルの読み込みに失敗しました");
					return;
				}
				this.loading = false;
			})
		},
		onClickCreateAlbum: function() {
			if (!this.$refs.form_title.validate())
				return;
			if (this.album === null || this.album.items.length === 0) {
				this.errorDialog('写真を選択してください');
				return;
			}

			let contractor_id = this.$route.params.contractor_id;
			let talkroom_id = this.$route.params.talkroom_id;
			let photoalbum_id = uuidv4();
			let images = [];

			this.album.items.forEach(item => {
				images.push(item.images.photo, item.images.thumbnail);
			});

			this.loading = true;
			this.uploadToConoHa(photoalbum_id, images)
				.then(async () => {
					await this.createMessagePhotoAlbum(contractor_id, talkroom_id, photoalbum_id, this.album);
				})
				.catch(() => {
					this.error('アルバムの作成に失敗しました');
				}).then(() => {
					this.loading = false;
				});
		},
		onClickDialogDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickDialogAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		onWindowResize: function() {
			Util.onWindowResize();
		},
		uploadToConoHa: async function(photoalbum_id, images) {
			let uploaded = [];
			let failure = [];
			await Util.chunkSplitPromiseAll(images, async (image) => {
				let id  = ['photoalbum', photoalbum_id, image.file_id].join('/') + image.size.SUFFIX;
				let headers = {
					'X-Object-Meta-name': encodeURIComponent(image.name),
					'Content-Disposition': 'attachment; filename=' + encodeURIComponent(image.name),
					'Content-Type': image.type,
				};
				try {
					let res = await this.conoha.upload(image.blob, headers, id);
					if (image.setURI)
						image.setURI(res);
					uploaded.push(res);
				} catch {
					failure.push(image.name);
				}
			});
			if (failure.length > 0) {
				throw ('upload error');
			}
		},
		deleteFromConoHa: function(items) {
			return Util.chunkSplitPromiseAll(items, async (item) => {
				await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		createMessagePhotoAlbum: async function(contractor_id, talkroom_id, photoalbum_id, album) {
			let title = album.title || strftime('%Y年%m月%d日', new Date());
			let items = album.items.map(item => {
				return {
					id: item.id,
					thumbnail_uri: item.thumbnail_uri,
					photo_uri: item.photo_uri,
				};
			});

			return this.api.createTalkMessagePhotoAlbum(talkroom_id, photoalbum_id, title, items)
				.then(() => {
					this.onClickBack();
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
	},
	computed: {
		styleImage: function() {
			if (this.is_selecting_images)
				return {'cursor': 'pointer'};
			return {};
		},
		placeholderTitle: function() {
			return strftime('%Y年%m月%d日', new Date());
		},
		cameraResolutionCaption: function() {
			if (this.is_camera_resolution_original)
				return '高画質';
			else
				return '標準';
		},
		isSelectedImage: function() {
			return (id) => this.selected_images.indexOf(id) >= 0;
		},
	},
	mounted() {
		this.msm.bind(window);
		this.api = new APIClient(this.$store);
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData();
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onWindowResize);
		this.msm.unbind();
	},
	beforeRouteUpdate(to, from, next) {
		this.initData();
		next();
	},
};
</script>
<style>
	.ms-talkmessage-edit-photoalbum {
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	.ms-talkmessage-edit-photoalbum .header {
		position: fixed;
		top: 0;
		left: 0;
	}

	.ms-talkmessage-edit-photoalbum .menu-list-group {
		top: 46px;
	}

	.ms-talkmessage-edit-photoalbum .album-title {
		color: white;
	}

	.ms-talkmessage-edit-photoalbum .btn-image-select {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	.ms-talkmessage-edit-photoalbum .selecting-menu {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		background-color: white;
		border-top: 1px solid;
	}

	.ms-talkmessage-edit-photoalbum .camera-menu {
		position: fixed;
		right: .5em;
		bottom: 1em;
		background-color: #9f9;
		border: 1px solid #3a3;
		border-radius: 2em;
		padding: 0 1em;
	}

	.ms-talkmessage-edit-photoalbum .camera-menu > .v-btn {
		min-width: 2.5em;
		width: 3em;
		margin: 0;
	}

	.ms-talkmessage-edit-photoalbum .camera-menu .menu-list-group {
		top: -7.5em;
		width: 8em;
	}

	.ms-talkmessage-edit-photoalbum .camera-menu .menu-list-item {
		height: 2em;
		margin: 0;
	}

	.ms-talkmessage-edit-photoalbum input[type=file] {
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
	}
</style>
